var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"pcaSelector"}},[_vm._v("\n\t时间选择器\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }